import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { PersonService } from "../../../services/person.service";

import { Person } from "../../../models/person.model";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogPersonComponent } from "../../dialog-person/dialog-person.component";

import { UserService } from "../../../@core/services/user.service";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-view-person",
  styleUrls: ["./view-person.component.scss"],
  templateUrl: "./view-person.component.html",
})
export class ViewPersonComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = ""; //home / person
  @Input() person: Person;
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "main";
  uid = "";
  isMobile = false;
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];

  constructor(
    public userService: UserService,
    private personService: PersonService,
    private dialogService: NbDialogService,
    private router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.person.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadContent(value) {
    this.isMore = value;
  }

  loadButtonAction(item) {
    this.menuItems = [
      { title: "Sửa", icon: "edit-2-outline", data: item },
      { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
      {
        title: "Chi tiết",
        icon: "external-link-outline",
        link: `/person/${this.person.id}`,
      },
    ];
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.personService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: Person) {
    let lecBk = new Person();
    lecBk = clone(item);
    this.dialogService
      .open(DialogPersonComponent, {
        context: {
          header: "Cập nhật bài viết",
          mode: "edit",
          person: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.person = value;
          this.onEdit.emit(value);
        }
      });
  }

  createHistory(item: Person) {
    //
  }

  createReceipt(item: Person) {
    // let lecNew = new History();
    // lecNew.personId = item.id;
    // lecNew.fullName = item.fullName;
    // lecNew.dobYear = item.dobYear;
    // lecNew.issueDate = new Date();
    // this.dialogService
    //   .open(DialogHistoryComponent, {
    //     context: {
    //       header: "Tạo trạng thái",
    //       mode: "new",
    //       history: lecNew,
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //     }
    //   });
  }

  viewHistory(item) {
    this.router.navigateByUrl("/person/" + item.id);
  }
}
